import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import {
  changePersonalityAnswer,
  getPersonalityQuestion,
  getPersonality,
  finishPersonality,
} from '../../../../ducks/respondent'
import styles from './PersonalityQuestion.module.scss'
import { Tile } from 'components/shared/Tile/Tile'
import SwipePage, { Slider } from 'components/common/SwipePage'
import {
  nextPage,
  previousPage,
  nextUnanswered,
  getQuizPage,
  getLocation,
} from 'ducks/router'
import { QuestionContainer } from 'components/shared/QuestionContainer/QuestionContainer'

const PersonalityQuestion = ({
  question,
  finished,
  totalQuestions,
  pageFromUrl,
  answered,
  nextPage,
  previousPage,
  nextUnanswered,
  questions,
  finishPersonality,
  changePersonalityAnswer,
  prompt,
  instrument,
  label = 'which number?',
  scale = { 1: 'one', 2: 'two', 3: 'three' },
  value = null,
  reversed,
}) => {
  const changeValue = value => {
    changePersonalityAnswer({ instrument, key: question, value })
    value && nextUnanswered()
  }

  if (!questions) {
    return null
  }

  const questionIndex = pageFromUrl + 1

  const tiles = R.pipe(
    R.mapObjIndexed((label, val) => (
      <Tile
        key={val}
        label={label}
        onClick={ev => {
          ev.preventDefault()
          ev.stopPropagation()
          changeValue(val == value ? null : val)
        }}
        selected={val === value}
      />
    )),
    R.values,
  )(scale)

  return (
    <QuestionContainer
      {...{
        questionIndex,
        totalQuestions,
        finished,
        previousPage,
        answered,
        nextUnanswered,
        nextPage,
      }}
      finishTest={() => finishPersonality()}
      collapse
    >
      <Slider page={prompt} reversed={reversed} slideSpeed={400}>
        <div className={styles.prompt}>{prompt}</div>
      </Slider>

      <SwipePage slideSpeed={400}>
        <div className={styles.swipePage}>
          <div className={styles.statement}>{label}</div>
          <div className={styles.tiles}>{tiles}</div>
        </div>
      </SwipePage>
    </QuestionContainer>
  )
}

const mapStateToProps = (state, { page }) => {
  const { value } = getPersonalityQuestion({ page })(state)
  const { totalQuestions, totalAnswers } = getPersonality(state)
  const finished = totalQuestions - totalAnswers === 0
  const pageFromUrl = Number(getLocation(state).payload.page)

  return {
    questions: state.respondent.personality.questions,
    finished,
    totalQuestions,
    totalAnswers,
    pageFromUrl,
    answered: value !== null,
    reversed: getQuizPage(state).reversed,
    ...getPersonalityQuestion(R.isNil(page) ? null : { page })(state),
  }
}

const mapDispatchToProps = {
  changePersonalityAnswer,
  nextPage,
  previousPage,
  nextUnanswered,
  finishPersonality,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonalityQuestion)
